import turfObj from "@turf/area";

export default function area(feature, options) {
    return turfObj(feature, options);
};
